import { render, staticRenderFns } from "./NeedRepair.vue?vue&type=template&id=d216c2a2&"
import script from "./NeedRepair.vue?vue&type=script&lang=js&"
export * from "./NeedRepair.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports